export default __webpack_public_path__ + "static/media/image_banner.54169995.png";